import UserLockboxes from './UserLockboxes';

export default UserLockboxes;